import React, { useState } from "react";
import OTPInput, { ResendOTP } from "otp-input-react";


function OTPVerification({values, state, setState, handleOTPRequest,navigation, handleOTPVerification, t}) {
 
  const [OTP, setOTP] = useState("");


  const RenderTime = (remainingtime) => {
    return <span>( {remainingtime}&nbsp;{t("SECONDS")} ) </span>;
  };

  const RenderButton = (buttonProps) => {
    return (
      <button {...buttonProps} className="resend-otp-btn">
        {t("RESEND_OTP")}
      </button>
    );
  };

  
  const handleOTP = (otp) =>{
    const otpValue = otp
    setOTP(otpValue);
    if(otpValue.length === 4){
        setState( {...state, isOtpEntered: true, otpValue: otpValue} );
        handleOTPVerification(otpValue);
       
    }else{
        setState( {...state, isOtpEntered: false, otpValue: otpValue} );
    }
  }
  return (
    <>
      <div className="otp-verification-sec p-4">
        <div className="row">
          <div className="col-sm-12 pb-2">
            <img src="./images/otp-icon.svg" alt="OTP Icon" />
          </div>
          <div className="col-sm-12 pb-2">
            <h3>
              {t("ENTER_OTP_SENT_TO")} <br /> <span className="d-inline-block always-ltr"><strong>+{values.mobileDialCode + " " + values.mobileNumber }</strong></span>
            </h3>
          </div>
          <div className="col-9 always-ltr otp-ip-wrap">
            <OTPInput
                value={OTP}
                onChange={handleOTP}
                autoFocus
                OTPLength={4}
                otpType="number"
                disabled={state.disableOtpInput}
                secure={false}
                inputClassName="otp-input"
            />
          </div>
          
          <div className="col-3">
              {state.otpVerification === "SUCCESS" && <><img src="./images/checkmark-circle.svg" alt="right otp" /></>}
              {state.otpVerification === "FAILED" && <><img src="./images/warning-circle.svg" alt="wrong otp" className="wrong-otp" /></>}
          </div>
          
        </div>

       

      </div>
      <div className="row">
        { (!state.isOtpEntered || state.otpVerification === "FAILED") && 
        <div className="col-sm-12 px-4 py-3 resend-otp-sec">
          <ResendOTP
            onResendClick={handleOTPRequest}
            maxTime={60}
            renderTime={RenderTime}
            renderButton={RenderButton}
            className="resend-otp"
          />
        </div>
        }
      </div>
    </>
  );
}

export default OTPVerification;
